<div ngbDropdown display="dynamic" placement="bottom-end">
  <button type="button"
    class="btn d-flex justify-content-between w-100 {{ isDisabled ? 'disabled' : '' }}"
    ngbDropdownToggle (click)="onOpenDropdown()">
    <span *ngIf="showIcon" class="icon"><i class="bi bi-{{ iconName }}"></i></span>
    <div class="inner d-flex justify-content-between w-100">
      <span class="text-gray-600" *ngIf="selectedOptionIsNotset()">{{ title }}</span>
      <span *ngIf="!selectedOptionIsNotset()" class="text-dark">{{ selectedOption }}</span>
      <span>
        <a *ngIf="!selectedOptionIsNotset()" class="ms-2" (click)="removeSelected($event)">
          <i class="bi bi-x fw-bold"></i>
        </a>
        <span class="ms-2">
          <app-ac-icon-arrow-down></app-ac-icon-arrow-down>
        </span>
      </span>
    </div>
  </button>
  <div ngbDropdownMenu class="w-100">
    <div class="p-2" *ngIf="showSearch">
      <input (input)="search()" [(ngModel)]="searchKey" #searchElement type="search" name="" class="form-control"
        placeholder="Type to search..." />
    </div>
    <div class="results">
      <button *ngFor="let item of filteredOptions" ngbDropdownItem (click)="onItemClick(item)"
        class="{{ selectedOption === item ? 'active ' + className: '' }}">{{ item }}</button>
    </div>
  </div>
</div>
